import { IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { Typography } from '@mui/material';

import useTranslation from '../../hooks/useTranslation';
import Icon from '../Icon/Icon';
import { IconWithTextStyles } from './IconWithText.styles';

type Props = {
    icon: FontAwesomeIconProps['icon'] | IconDefinition;
    text: string;
    iconSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | undefined;
};

const IconWithText = ({ icon, text, iconSize }: Props) => {
    const translate = useTranslation();
    return (
        <IconWithTextStyles>
            <Icon icon={icon} size={iconSize} />
            <Typography variant="body1">{translate(text)}</Typography>
        </IconWithTextStyles>
    );
};

export default IconWithText;
